import React from 'react';
import { Input } from 'antd';
import type { GetProps } from 'antd';

type OTPProps = GetProps<typeof Input.OTP>;

interface InputOtpProps extends Omit<OTPProps, 'length'> {
  length?: number;
}

export const InputOtp: React.FC<InputOtpProps> = ({ length = 6, ...props }) => {
  return <Input.OTP length={length} {...props} />;
};
